import React from 'react'
import { useFilters } from '../context/FiltersContext'
import { FilterCategoryType } from '../types'

interface Props {
  category: FilterCategoryType
}

export const ToggleAll: React.FC<Props> = ({ category }) => {
  // NB: safe guard against colour for now as it's a different structure
  if (category === 'colour') return null

  const { activeFilters, filters, setActiveFilters, setTitle } = useFilters()
  const allRanges = filters[category].filter(r => r.title !== 'Clearance')
  const activeRanges = activeFilters[category]
  const allActive = allRanges.length == activeRanges.size

  const toggleAllRange = () => {
    if (allActive) {
      setActiveFilters({
        ...activeFilters,
        range: new Set(),
      })
    } else {
      setActiveFilters({
        ...activeFilters,
        range: new Set(allRanges.map(range => range.title)),
      })
    }

    setTitle('Leather Sofas and Chairs')
  }

  const className = allActive ? '__checked' : undefined

  return (
    <div className="refineby-all">
      <label className={className}>
        <input checked={allActive} onChange={toggleAllRange} type="checkbox" />
        Toggle All
      </label>
    </div>
  )
}
